module.exports = __webpack_public_path__ + "img/cmri.4cfed77.png";